// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateAppointment_wrapper__lPnXG","logo":"CreateAppointment_logo__d5zcU","main_container":"CreateAppointment_main_container__SsMSP"};